// extracted by mini-css-extract-plugin
export default {"IssueTypeToken":"IssueType-module__IssueTypeToken--Vdjny","hiddenPlaceholder":"IssueType-module__hiddenPlaceholder--ZeIBK"};